var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 4.8335C5 6.4875 6.346 7.8335 8 7.8335C9.654 7.8335 11 6.4875 11 4.8335C11 3.1795 9.654 1.8335 8 1.8335C6.346 1.8335 5 3.1795 5 4.8335ZM13.3333 14.5002H14V13.8335C14 11.2608 11.906 9.16683 9.33333 9.16683H6.66667C4.09333 9.16683 2 11.2608 2 13.8335V14.5002H13.3333Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7fafd3ecbb3ed10f45ebc0659866e69c.svg";
export { ForwardRef as ReactComponent };